<template>
  <div class="supporting-roll_list" v-if="paperData.length>0" :style="{height: isExpand?'400px':'auto'}">
    <div class="title">
      <div>配套卷</div>
      <div></div>
    </div>
    <div class="supporting-roll" v-for="(item, index) in paperData" :key="index">
      <div class="header" :title="item.catalogName">{{ item.catalogName }}</div>
      <div class="title1" v-for="(items, indexs) in item.paperList" :key="indexs">
        <div class="paperName_name" :title="items.sourceName" style="width: 46%">
          {{ items.sourceName }}
        </div>
        <div style="width: calc(100% - 46% - 72px)">
          <div class="usetime">
            题目数量：{{ items.questionCount }}
          </div>
        </div>
        <div class="answer-btn" @click="answer(items)">
          答题
        </div>
      </div>
    </div>
    <!-- 展开收起 -->
     <div v-if="isShow" class="expand-collapse">
      <div class="expand-collapse-btn" @click="isExpand=!isExpand">
        {{isExpand?'展开':'收起'}}<i :class="isExpand?'el-icon-arrow-down':'el-icon-arrow-up'"></i>
      </div>
    </div>
  </div>
</template>
<script>

import { getGoodsCatalogAndFiles } from '@/api/bookstore/bookstore.js'
export default {

  name: 'supportingRoll',
  data() {
    return {
      paperData: [],
      isExpand: true,
      isShow: false
    }
  },
  mounted() {

    // console.log(Utils.getBrowserFingerprint(), 'xmlksdfjsklfksldfks');

    getGoodsCatalogAndFiles({ goodsId: this.$route.query.goodsId }).then(res => {
      console.log(res, 'res');
      this.paperData = res.data || []
      let paperNumber = 0
      this.paperData.map((item)=>{
        paperNumber += item.paperList.length
      })
      if(this.paperData.length>0){
        this.$emit("shoPeiTao",true)
      }else{
        this.$emit("shoPeiTao",false)
      }
      if(paperNumber>4){
        this.isExpand = true
        this.isShow = true
      }else{
        this.isExpand = false
        this.isShow = false
      }
    })

  },
  methods: {
    answer(item) {
      this.$router.push({
        path: "/bookstore/examination",
        query: {
          testPaperId: item.filesId,
          userId: this.$store.state.user.userId,
          userName: this.$store.state.user.name,
          goodsId: this.$route.query.goodsId,
          fromType: "/user/myResources",
          params2:"peitaojuan"
          // bookName: this.bookName,
          // showAi:
          //   JSON.stringify(this.robotBook).indexOf(
          //     this.$route.query.goodsId
          //   ) !== -1
          //     ? true
          //     : false,
        },
      });
    },
    // 格式化时间
    getTime(time) {
      if (time) {
        let m = parseInt(time / 60);
        let s = time % 60;
        let date = (m > 9 ? m : "0" + m) + "分" + (s > 9 ? s : "0" + s) + "秒";
        return date;
      } else {
        return "";
      }
    },
  },
}
</script>


<style scoped lang="scss">
.supporting-roll_list {
   width: 100%;
  margin: 16px auto 16px auto;
  background: #fffefd;
  position: relative;
  padding-bottom: 40px;
  overflow: hidden;

  .title {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 14px 80px;
    font-weight: 600;
    font-size: 18px;
    color: #333333;
  }

  .supporting-roll {
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;

    .header {
      display: flex;
      flex-direction: row;
      align-items: center;
      background: #f8f8f8;
      font-family: PingFang SC, PingFang SC;
      margin: 0 auto;
      width: calc(100% - 40px);
      height: 42px;
      padding: 0 60px;
      line-height: 42px;
      font-weight: 500;
      font-size: 16px;
      color: #666666;
      // 文字移除...
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .title1 {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-family: PingFang SC;
      padding: 20px 80px;
      color: #666666;
      border-bottom: 1px solid #F2F2F2;

      .paperName_name {
        white-space: nowrap;
        font-size: 16px;
        font-weight: 600;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
      }

    }
  }

  .answer-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 72px;
    height: 30px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 2px solid #0081CE;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #0081CE;
    cursor: pointer;
  }

  .expand-collapse{
    position: absolute;
    left: 0;
    bottom: 0;
    justify-content: center;
    height: 40px;
    width: 100%;
    background-color: #FFFFFF;
    .expand-collapse-btn{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 4px 10px;
      cursor: pointer;
      .el-icon-arrow-down,.el-icon-arrow-up{
        font-weight: 600;
        margin-left: 6px;
      }
        

      &:hover{
        color: #7aafff;
      }
    }
  }

}
</style>